import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import Step1 from "./Steps/Step1";
import { config } from "../../../config/envs";

const INITIAL_VALUES = {
  coupom: "",
  feature_group_id: "",
  amount: 0.00,
  old_amount: 0.00,
  periodicity: "",
  installments: "",
  trial_days: "",
  valid_until: "",
  description: "",
  subtitle: "",
  upfront_credit_card_required: true
};

/** ISO ou datetime da API → yyyy-MM-dd (formato exigido por input type="date"). */
function toDateInputValue(value) {
  if (value === null || value === undefined || value === "") return "";
  const s = String(value).trim();
  const head = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (head) return head[1];
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return "";
  return d.toISOString().slice(0, 10);
}

function validUntilToIso(values) {
  const day = toDateInputValue(values.valid_until);
  if (!day) return values.valid_until;
  return new Date(`${day}T12:00:00.000Z`).toISOString();
}

export default function AddCoupons(props) {
  const history = useHistory();
  const [initialValues, setInitialValues] = useState(INITIAL_VALUES);
  const couponId = props.match.params.coupon_id;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInitialValues = async () => {
      if (couponId) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/coupons/${couponId}`);
          const { coupon, plan } = response.data.data;
          const merged = { ...coupon, ...plan };
          merged.valid_until = toDateInputValue(merged.valid_until);
          setInitialValues(merged);
        } catch (error) {
          console.error("Erro ao buscar os dados do cupom", error);
          toast.error("Erro ao carregar dados iniciais.");
        }
      }
      setLoading(false);
    };
    fetchInitialValues();
  }, [couponId]);

  async function onCreate(values) {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/plans`, {
      description: values.description,
      feature_group_id: values.feature_group_id,
      amount: values.amount,
      old_amount: values.old_amount,
      installments: values.installments,
      periodicity: values.periodicity,
      trial_days: values.trial_days,
      coupom: values.coupom,
      valid_until: values.valid_until,
      subtitle: values.subtitle,
      upfront_credit_card_required: values.upfront_credit_card_required,
      is_coupom: true,
      max_redeems: values.max_redeems || 0
    });
    return response.data;
  }

  async function onEdit(values) {
    const response = await axios.patch(`${config.app.adminBaseUrl}/coupons/${couponId}`, {
      description: values.description,
      feature_group_id: values.feature_group_id,
      old_amount: values.old_amount,
      installments: values.installments,
      periodicity: values.periodicity,
      trial_days: values.trial_days,
      coupom: values.coupom,
      valid_until: validUntilToIso(values),
      subtitle: values.subtitle,
      upfront_credit_card_required: values.upfront_credit_card_required,
      max_redeems: values.max_redeems || 0
    });
    return response.data;
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      try {
        if (couponId) {
          await onEdit(values);
        } else {
          await onCreate(values);
        }
        toast.success("Cupom salvo com sucesso!");
        history.push("/coupons");
      } catch (error) {
        toast.error("Ops... tivemos um problema de conexão por isso não conseguimos salvar seu cupom.");
        console.error(error);
      } finally {
        setSubmitting(false);
      }
    },
    validationSchema: yup.object().shape({
      description: yup.string().required("O campo nome é obrigatório!"),
      feature_group_id: yup.number().required("O campo grupo de planos é obrigatório!"),
      amount: yup.number().required("O campo valor é obrigatório!"),
      old_amount: yup.number().required("O campo Valor sem desconto é obrigatório!"),
      installments: yup.number().required("O campo parcelas é obrigatório!"),
      periodicity: yup.number().required("O campo duração é obrigatório!"),
      trial_days: yup.number().required("O campo dias de trial é obrigatório!"),
      coupom: yup.string().required("O campo Código do Cupom é obrigatório!"),
      valid_until: yup.date().required("O campo Validade do Cupom é obrigatório!"),
      subtitle: yup.string().required("O campo Descrição é obrigatório!"),
      upfront_credit_card_required: yup.boolean().required("O campo Pagamento Imediato é obrigatório!"),
    })
  });
  if (loading) {
    return <div>Carregando...</div>;
  }

  return <Step1 step={0} setStep={() => { }} formik={formik} id={couponId} />;
}
